<div class="outer-content">
  <div class="container" style="display: flex;justify-content: center;">
    <div class="modal card-background-copy" id="modal-dialog" tabindex="-1">
      <form [formGroup]="yourPersonalDetailForm" autocomplete="off" role="form" class=" ">
        <div class="float-left bg-white wd-total">

          <app-content-top-nav [parentElement]="el" [parentFormToValidate]="yourPersonalDetailForm" [visibleBackNav]='true' [enableBackNav]='true' (onBackClickHandler)="onBackClick()"></app-content-top-nav>

          <div class="col-md-12 clear-all title-wrapper">
            <h1 class="responsive-text-8" id="personal-header">{{contentData.header}} </h1>
          </div>

          <div class="col-md-12 clear-all content-wrapper">
            <p class="content-top" id="personal-introduction">
              {{contentData.introduction}}
            </p>
          </div>

          <div class="col-md-12 mar-tlr-40 bg-lightblue">
              <p class="inner-content-data pad-lr-0" id="personal-introduction">
                {{contentData.subtitle}}
                <strong><a (click)="blurHandler()" tabindex="0" target="_blank" id="anchor_privacy-policy" class="disable-link">{{contentData.updateText}}</a></strong>
              </p>
            <p class="inner-content-data pad-lr-0" id="defined-benefit">{{contentData.noteStatement}}</p>
          </div>

          <div class="col-md-12 wrapperMargin content-wrapper padding-tab">

            <div class="col-md-5 clear-all">

              <app-dropdown [dropdownConfig]="titleConfig" [pageName]="'your-personal-details'" [controlName]="'title'" [parent]="yourPersonalDetailForm"
                (onChangeHandler)="detectChange()">
              </app-dropdown>
            </div>
            <div class="col-md-12 clear-all margin-top-30 form-field" *ngIf="enableOtherTitle">
              <div class="form-field col-md-5 clear-all" [ngClass]="{'has-error': yourPersonalDetailForm.get('otherTitle').touched
            && yourPersonalDetailForm.get('otherTitle').errors}">
                <div class="dropdown-control">
                  <label id="othTitle" class="form-label"> {{contentData.otherTitle }}</label>

                </div>
                <div class="form-field-select">
                  <select id="your-personal-details-otherTitle" formControlName="otherTitle" class="form-control some" aria-invalid="false"
                    [ngModel]="yourPersonalDetails && yourPersonalDetails.otherTitle ? yourPersonalDetails.otherTitle : 
                      (loggedinDetails && loggedinDetails.customer.otherTitle ? loggedinDetails.customer.otherTitle : null)">

                    <option [disabled]="false" [ngValue]="null">Please select</option>
                    <option *ngFor="let otherTitle of otherTitleList" [value]="otherTitle.description">
                      {{otherTitle.description}}</option>
                  </select>
                  <i class="icon icon-chevron-down" aria-hidden="true"></i>
                </div>

                <div class="form-validation-error" *ngIf="yourPersonalDetailForm.get('otherTitle').touched
                                  && yourPersonalDetailForm.get('otherTitle').errors 
                                  && yourPersonalDetailForm.get('otherTitle').hasError('required')">
                  <i class="icon icon-error" aria-hidden="true"></i>
                  <p>Please select other title</p>
                </div>
              </div>
            </div>
          </div>


          <div class="col-md-12 content-wrapper padding-tab">
            <div class="col-md-12 clear-all" *ngIf="forenameData!=''">
              <p class="question-font">First name</p>
              <!-- </div> -->
              <!-- <div class="col-md-12 margin-left-30"> -->
              <p class="text-color values-font">{{forenameData}}</p>
            </div>

             <!-- <div class="col-md-12 content-wrapper margin-top-30"> -->
            <div class="col-md-12 clear-all" *ngIf="middleNameData!=''">
              <p class="question-font">Second name</p>
              <!-- </div> -->
              <!-- <div class="col-md-12 margin-left-30"> -->
              <p class="text-color values-font">{{middleNameData}}</p>
            </div>
            <div class="col-md-2" *ngIf="middleNameData!=''"></div>

            <div class="col-md-2"></div>
            <!-- <div class="col-md-12 content-wrapper margin-top-30"> -->
            <div class="col-md-12 clear-all" *ngIf="surnameData!=''">
              <p class="question-font">Surname</p>
              <!-- </div> -->
              <!-- <div class="col-md-12 margin-left-30"> -->
              <p class="text-color values-font">{{surnameData}}</p>
            </div>
                       
            <!-- <div class="col-md-12 content-wrapper margin-top-30"> -->
            <div class="col-md-12 clear-all" *ngIf="thirdNameData!=''">
              <p class="question-font">Third name</p>
              <!-- </div> -->
              <!-- <div class="col-md-12 margin-left-30"> -->
              <p class="text-color values-font">{{thirdNameData}}</p>
            </div>
          

          <!-- <app-nametext-input [pageName]="'your-personal-details'" [controllerData]="forenameTextCodeConfig" [parent]="yourPersonalDetailForm"
                [controlName]="'forename'" (textChangeEventEmitter)="nameChangeHandler(forenameTextCodeConfig)">
              </app-nametext-input> -->

          <!-- <app-nametext-input [pageName]="'your-personal-details'" [controllerData]="surnameTextCodeConfig" [parent]="yourPersonalDetailForm"
                [controlName]="'surname'" (textChangeEventEmitter)="nameChangeHandler(surnameTextCodeConfig)">
              </app-nametext-input> -->


          <!--<div class="col-md-12 clear-all content-wrapper">
            <div class="col-md-5 clear-all">
              <app-nametext-input [pageName]="'your-personal-details'" [controllerData]="middleNameTextCodeConfig" [parent]="yourPersonalDetailForm"
                formControlName="middleName" [controlName]="'middleName'">
              </app-nametext-input>
            </div>

            <div class="col-md-2"></div>

            <div class="col-md-5 clear-all">
              <app-nametext-input [pageName]="'your-personal-details'" [controllerData]="thirdNameTextCodeConfig" [parent]="yourPersonalDetailForm"
                formControlName="thirdName" [controlName]="'thirdName'">
              </app-nametext-input>
            </div>
          </div>-->

          <div class="col-md-12 clear-all">
            <p class="question-font">Date of birth</p>
            <p class="text-color values-font">{{dateOfBirthData}}</p>
          </div>

          <div class="col-md-12 clear-all">
            <p class="question-font">Gender</p>
            <p class="text-color values-font">{{genderData}}</p>
          </div>

          <div class="col-md-12 clear-all">
            <p class="question-font">Marital status</p>
            <p class="text-color values-font">{{maritalStatusData}}</p>          
          </div>
        
          <div class="col-md-12 content-wrapper pd-lft">
            <p class="question-font">Address line 1</p>       
            <p class="text-color values-font">{{addressLine1Data}}</p>
          </div>
        
          <ng-container *ngIf="addressLine2Data">
            <div class="col-md-12 content-wrapper pd-lft">
              <p class="question-font">Address line 2</p>            
              <p class="text-color values-font">{{addressLine2Data}}</p>
            </div>
          </ng-container>

          <ng-container *ngIf="addressLine3Data">
            <div class="col-md-12 content-wrapper pd-lft">
              <p class="question-font">Address line 3</p>
              <p class="text-color values-font">{{addressLine3Data}}</p>
            </div>
          </ng-container>
          <ng-container *ngIf="addressLine4Data">
            <div class="col-md-12 content-wrapper pd-lft">
              <p class="question-font">Address line 4</p>
              <p class="text-color values-font">{{addressLine4Data}}</p>
            </div>
          </ng-container>
          <ng-container *ngIf="postCodeData">
            <div class="col-md-12 content-wrapper pd-lft">
              <p class="question-font">Postcode</p>
              <p class="text-color values-font">{{postCodeData}}</p>
            </div>
          </ng-container>
          <div class="col-md-12 clear-all content-wrapper margin-top-30 pd-lft">
            <div class="col-md-5 clear-all">
              <app-email [pageName]="'your-personal-details'" [parent]="yourPersonalDetailForm" [controllerData]="emailTextCodeConfig" 
                [loggedInFlag]="loggedinDetails && loggedinDetails.customer.registrationStatus"
                formControlName="emailAddress" [controlName]="'emailAddress'">
              </app-email>
            </div>
          </div>
          <div class="col-md-12 clear-all content-wrapper margin-top-30 pd-lft">
            <div class="col-md-5 clear-all">
              <app-email [pageName]="'your-personal-details'" [parent]="yourPersonalDetailForm" [controllerData]="confirmEmailTextCodeConfig"
                [controlName]="'confirmEmailAddress'" formControlName="confirmEmailAddress">
              </app-email>
            </div>
          </div>
          <div class="col-md-12 clear-all content-wrapper margin-top-30 pd-lft">

            <div class="col-md-5 clear-all">
              <app-contactNo [pageName]="'your-personal-details'" [parent]="yourPersonalDetailForm" [controllerData]="mobilePhoneCodeConfig"
                formControlName="mobilePhone" [controlName]="'mobilePhone'">
              </app-contactNo>
            </div>
          </div>

          <div class="col-md-12 clear-all content-wrapper margin-top-30 padding-left-40 pd-lft">

            <div class="col-md-5 clear-all">
              <app-contactNo [pageName]="'your-personal-details'" [parent]="yourPersonalDetailForm" [controllerData]="homePhoneCodeConfig"
                formControlName="homePhone" [controlName]="'homePhone'">
              </app-contactNo>
            </div>
          </div>

          <div class="col-md-12 clear-all content-wrapper pd-lft">
            <div class="col-md-5 clear-all">
              <app-national-insurance-number [pageName]="'your-personal-details'" [controllerData]="ninoCodeConfig" [parent]="yourPersonalDetailForm"
                formControlName="nino" [controlName]="'nino'">
              </app-national-insurance-number>
            </div>
          </div>
        </div>

          <!-- <ng-container *ngIf="!ninoData">
            <div class="col-md-12 content-wrapper margin-top-30">
              <p class="question-font">National insurance number</p>
            </div>
            <div class="col-md-12 margin-left-30">
              <p class="text-color values-font">{{ninoData}}</p>
            </div>
          </ng-container> -->


          <!-- <div class="col-md-12 clear-all margin-top-0">
            <app-question [childId]="'contactPref'" [questionConfig]="contactPrefCodeConfig" [parent]="yourPersonalDetailForm" [controlName]="'contactPref'"
              (toggleChange)="getToggleValue($event)">
            </app-question>
          </div> -->

          <div class="col-md-12 underline margin-top">
          </div>

          <div class="col-md-12 clear-all bottom-container">
            <div class="float-left">
              <app-save [parentElement]="el" [parentFormToValidate]="yourPersonalDetailForm" [location]="'contentBottom'"></app-save>
            </div>
            <div class="float-right">
              <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="afterApplyDetail['buttonConfig']" [buttonType]="'normalCTA'"></app-content-bottom-nav>
            </div>
          </div>

        </div>
      </form>
    </div>
  </div>
</div>